import * as React from "react";
import { Button, Grid } from "components/controls/widget";
import Dialog, { DialogProps } from "./Dialog";

export interface YesNoDialogProps {
    show: boolean;
    submitting?: boolean;
    handleClose: (cancel: boolean) => void;
    title: React.ReactNode;
    yesBtnText?: string;
    noBtnText?: string;
    disableBackdropClick?: boolean;
    disableEscapeKeyDown?: boolean;
    fullScreen?: boolean;
    fullWidth?: boolean;
    maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false;
}

class YesNoDialog extends React.PureComponent<YesNoDialogProps> {

    render() {
        const { show, handleClose, title, noBtnText, yesBtnText, children, submitting, ...other } = this.props;
        const yesBtnStr = yesBtnText || 'Ano';
        const noBtnStr = noBtnText || 'Ne';

        const dlgProps: DialogProps = {
            ...other,
            open: show,
            onClose: () => handleClose(true),
            title: title,
            actions: <Grid container direction="row" justify="space-between" spacing={8}>
                <Grid item xs={6} />
                <Grid item xs={3} ><Button color="success" variant="contained" fullWidth disabled={submitting === true} onClick={() => handleClose(false)}>{yesBtnStr}</Button></Grid>
                <Grid item xs={3} ><Button color="primary" variant="contained" fullWidth disabled={submitting === true} onClick={() => handleClose(true)}>{noBtnStr}</Button></Grid>
            </Grid>
        }
        return <Dialog {...dlgProps}>{children}</Dialog>
    }
}

export default YesNoDialog;
